// components/PreEmployment/PreEmploymentHeader.tsx

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import type { PreEmploymentHeaderProps } from '../../../types/preEmployment.types';

const PreEmploymentHeader: React.FC<PreEmploymentHeaderProps> = ({ onBack }) => {
  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      // Fallback au comportement par défaut du navigateur si aucune fonction onBack n'est fournie
      window.history.back();
    }
  };

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
            Certificat Médical Pré-embauche
          </h1>
          <p className="text-gray-600 mt-1">
            Sélection du statut médical et génération du certificat
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handleBackClick}
            className="flex items-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-1"
          >
            <ArrowLeft size={18} />
            Retour
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreEmploymentHeader;